import styled from 'styled-components';

export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  default as Text,
} from './Text';
// export { default as Link } from './Link';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  default as Header,
} from './Header';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  default as Statistic,
} from './Statistic';
export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  default as Highlight,
} from './Highlight';

const Strong = styled.strong`
  font-weight: 600;
  font-size: inherit;
`;

Strong.displayName = 'Strong';

export {
  /** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
  Strong,
};
